
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetotrimbkeshwarcabs() {



    const cardData =
    {
        keyword: 'Pune to Trimbakeshwar Cabs',
        heading: 'Platinum24 Cabs: Pune to Trimbakeshwar Cabs',
        headingDescription: ' Platinum24 Cabs offers reliable Pune to Trimbakeshwar Cabs, perfect for devotees visiting the sacred Trimbakeshwar Jyotirlinga Temple near Nashik. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a safe and comfortable journey on this holy route, with spacious seating and air-conditioned comfort. With professional chauffeurs familiar with the Pune–Trimbakeshwar highway, we guarantee punctual pickups, smooth rides, and convenient halts along the way. Whether it’s a family pilgrimage, a group yatra, or a weekend trip, Platinum24 Cabs provides affordable fares, transparent pricing, and dependable service for your Pune to Trimbakeshwar journey.',

        top: 'Top Places to Visit in Trimbakeshwar with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Trimbakeshwar Jyotirlinga Temple",
    "description": "Trimbakeshwar is one of the 12 Jyotirlingas of Lord Shiva, located at the foothills of Brahmagiri near Nashik. The temple’s black stone Nagara-style architecture and sacred lingam representing Brahma, Vishnu, and Mahesh make it unique. It is also the source of the holy Godavari River. Rituals like Narayan Nagbali, Kalsarpa Shanti, and Pitru Dosh Nivaran are performed here. Pilgrims believe darshan brings peace, prosperity, and liberation. Trimbakeshwar is Maharashtra’s eternal center of devotion and rituals."
  },
  {
    "title": "Brahmagiri Hill",
    "description": "Brahmagiri Hill, towering above Trimbakeshwar, is considered the birthplace of the Godavari River. Pilgrims climb hundreds of steps to reach the top, where small shrines and holy kunds are located. The panoramic views of Trimbak town and surrounding hills are mesmerizing. Legends connect the hill to Lord Shiva and Sage Gautama. Devotees believe the climb purifies sins and grants blessings. Brahmagiri is Trimbakeshwar’s sacred hill of divinity and adventure."
  },
  {
    "title": "Kushavarta Kund",
    "description": "Kushavarta Kund is a holy tank near the Trimbakeshwar temple, regarded as the symbolic origin of the Godavari River. Pilgrims take ritual baths here before entering the temple. The kund is surrounded by ancient stone steps and shrines. It is a hub for performing pind daan and other sacred rituals. The atmosphere is spiritual, especially during Kumbh Mela. Kushavarta Kund is Trimbakeshwar’s sacred water body of purification."
  },
  {
    "title": "Anjaneri Hills",
    "description": "Anjaneri Hills, located near Trimbakeshwar, is believed to be the birthplace of Lord Hanuman. The trek to the top takes visitors through lush greenery, waterfalls, and caves. Ancient temples and carvings are scattered across the hill. Pilgrims and trekkers both find it fascinating for its mythological and natural charm. Sunrise views from here are breathtaking. Anjaneri is Trimbakeshwar’s nearby divine trekking destination."
  },
  {
    "title": "Neel Parbat",
    "description": "Neel Parbat is a sacred hill near Brahmagiri associated with Lord Shiva and Goddess Parvati. The site features small temples, caves, and holy ponds. It is visited by pilgrims during festivals and yatra days. The climb is rewarding with scenic views of valleys and rivers. Legends say saints meditated here for divine knowledge. Neel Parbat is Trimbakeshwar’s spiritual retreat amidst nature."
  },
  {
    "title": "Gangadwar",
    "description": "Gangadwar, located on Brahmagiri Hill, is a holy cave and shrine marking the descent of the Godavari River. Pilgrims trek uphill to offer prayers here. The cave has a small Shiva temple and sacred kunds. It is considered as holy as the Ganga in Haridwar. The site is peaceful, with chants and the sound of flowing water creating a mystical aura. Gangadwar is Trimbakeshwar’s divine gateway of the Ganga."
  },
  {
    "title": "Gorakhnath Caves",
    "description": "The Gorakhnath Caves near Trimbakeshwar are associated with Guru Gorakhnath, a famous Nath yogi. The caves are carved into the hillside and used for meditation and penance. Pilgrims visit to seek blessings and spiritual energy. The caves also offer panoramic views of the valley. Their simplicity and silence attract seekers of inner peace. Gorakhnath Caves are Trimbakeshwar’s ancient seat of yogic tradition."
  },
  {
    "title": "Kumbh Mela Grounds, Nashik-Trimbak",
    "description": "Trimbakeshwar is one of the four holy sites where the Kumbh Mela is held every 12 years. The grounds near Kushavarta Kund and Godavari ghats host millions of pilgrims. Ritual baths, processions of saints, and devotional chants create an electrifying atmosphere. Temporary camps offer satsangs and annadan seva. The festival is a once-in-a-lifetime experience for devotees. Kumbh Mela makes Trimbakeshwar the global epicenter of faith."
  },
  {
    "title": "Narayan Nagbali Pooja Centers",
    "description": "Trimbakeshwar is renowned for Narayan Nagbali and related rituals performed by specialized priests. These poojas help devotees overcome Pitru Dosh, Kalsarpa Dosh, and ancestral issues. Pilgrims from across India visit specifically for these remedies. The rituals are performed at designated sacred places near the temple. Families believe performing them grants peace to ancestors and prosperity to descendants. These poojas are Trimbakeshwar’s spiritual remedies of tradition."
  },
  {
    "title": "Coin Museum, Nashik",
    "description": "Located around 25 km from Trimbakeshwar, the Indian Institute of Numismatics houses the only Coin Museum in India. It showcases ancient coins, currency, and economic history of India. Visitors explore exhibits from the pre-Mauryan to modern times. The museum is educational and fascinating for history enthusiasts. Combined with Trimbak’s spiritual journey, it adds a cultural touch. The Coin Museum is Trimbakeshwar’s nearby knowledge hub."
  }
],



     "services": [
    {
      "name": "Pune to Trimbakeshwar Taxi Service",
      "description": "Experience a spiritually enriching journey with our Pune to Trimbakeshwar taxi service. Perfect for pilgrimage seekers, this service offers comfortable vehicles, courteous drivers, and flexible pickup options from anywhere in Pune. Enjoy a safe and timely ride to one of Maharashtra's most sacred Jyotirlingas."
    },
    {
      "name": "Trimbakeshwar Cab from Pune",
      "description": "Book a reliable cab from Pune to Trimbakeshwar for a peaceful temple visit. Our fleet includes AC sedans, SUVs, and tempo travellers, making the trip suitable for families, solo pilgrims, and groups. Drivers are familiar with the route and temple timings for a hassle-free experience."
    },
    {
      "name": "Pune Trimbakeshwar Taxi Booking",
      "description": "Easily book your Trimbakeshwar taxi from Pune online or via phone with instant confirmation. We offer competitive pricing, multiple car options, and door-to-door pickup. Ideal for early morning temple visits and full-day return journeys."
    },
    {
      "name": "Taxi for Trimbakeshwar Pilgrimage Pune",
      "description": "Specialized taxi service for Trimbakeshwar pilgrimage from Pune. Whether you’re visiting for darshan, abhishek, or religious ceremonies, our service ensures timely arrival, devotional ambience, and a comfortable ride throughout your spiritual trip."
    },
    {
      "name": "Pune to Trimbakeshwar Car Rental",
      "description": "Choose from a wide range of car rental options for your Pune to Trimbakeshwar journey. Available with or without a driver, our rentals come in daily and per-kilometer plans. Select hatchbacks, sedans, SUVs, or luxury cars as per your preference."
    },
    {
      "name": "Trimbakeshwar Taxi Packages Pune",
      "description": "All-inclusive taxi packages for Trimbakeshwar visits from Pune. Packages cover round trips, temple visit durations, waiting time, fuel, tolls, and driver allowances. Perfect for families and groups looking for a pre-planned spiritual tour."
    },
    {
      "name": "Affordable Cab Pune to Trimbakeshwar",
      "description": "Get budget-friendly cabs from Pune to Trimbakeshwar without compromising on comfort or service quality. Transparent pricing, no hidden charges, and professional support make this the preferred option for economical pilgrimage travel."
    },
    {
      "name": "Pune Trimbakeshwar Private Taxi",
      "description": "Enjoy a private, personalized taxi ride from Pune to Trimbakeshwar. Get peace of mind with a dedicated driver, flexible temple visit timings, and the freedom to stop at scenic spots along the way."
    },
    {
      "name": "Pune to Trimbakeshwar Taxi Fare",
      "description": "Check clear and updated taxi fares for Pune to Trimbakeshwar trips. Fare includes fuel, driver charges, and applicable taxes. Compare options for different car types including Dzire, Ertiga, Innova, and more."
    },
    {
      "name": "Trimbakeshwar Cab Charges Pune",
      "description": "Detailed cab charges for Pune to Trimbakeshwar route across various vehicle categories. Get fare breakdowns for one-way and round-trip journeys to help plan your travel budget in advance."
    },
    {
      "name": "Pune to Trimbakeshwar Taxi Hire",
      "description": "Hire a cab from Pune to Trimbakeshwar for single-day visits or overnight stays. Available for families, solo pilgrims, and senior citizens with special assistance if required. Easy booking and reliable service."
    },
    {
      "name": "Trimbakeshwar Temple Taxi Service Pune",
      "description": "Special temple taxi service from Pune to Trimbakeshwar for darshan, rituals, and spiritual exploration. Cabs available for early morning temple entry and VIP access (if arranged by user)."
    },
    {
      "name": "Pune to Trimbakeshwar One Way Cab",
      "description": "Book a one-way cab from Pune to Trimbakeshwar for a cost-effective travel option. Ideal for those staying longer at the temple town or continuing their journey elsewhere. No return fare charged."
    },
    {
      "name": "Pune Trimbakeshwar Taxi with Driver",
      "description": "Taxi service with experienced and polite drivers who are familiar with the Pune-Trimbakeshwar route. Drivers assist with temple information, food stops, and safe navigation through ghats."
    },
    {
      "name": "Taxi Service Pune to Trimbakeshwar",
      "description": "Premium taxi services from Pune to Trimbakeshwar available 24/7. Choose your preferred car type, pickup time, and enjoy safe, smooth, and spiritual travel with our professional drivers and clean vehicles."
    }
  ],
  "tableData": [
    ["Pune to Trimbakeshwar Taxi Service", "Trimbakeshwar Cab from Pune"],
    ["Pune Trimbakeshwar Taxi Booking", "Taxi for Trimbakeshwar Pilgrimage Pune"],
    ["Pune to Trimbakeshwar Car Rental", "Trimbakeshwar Taxi Packages Pune"],
    ["Affordable Cab Pune to Trimbakeshwar", "Pune Trimbakeshwar Private Taxi"],
    ["Pune to Trimbakeshwar Taxi Fare", "Trimbakeshwar Cab Charges Pune"],
    ["Pune to Trimbakeshwar Taxi Hire", "Trimbakeshwar Temple Taxi Service Pune"],
    ["Pune to Trimbakeshwar One Way Cab", "Pune Trimbakeshwar Taxi with Driver"],
    ["Taxi Service Pune to Trimbakeshwar", "—"]
  ],


        "whychoose": [
    {
      "WhyChooseheading": "Trusted Pune to Trimbakeshwar Cab Service",
      "WhyChoosedescription": "Platinum24 Cabs offers reliable and comfortable cab rides from Pune to Trimbakeshwar for a smooth spiritual journey."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Trimbakeshwar Routes",
      "WhyChoosedescription": "Our professional drivers know the best routes to ensure safe and timely travel."
    },
    {
      "WhyChooseheading": "Clean and Comfortable Vehicles for Long-Distance Travel",
      "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs designed for your comfort and convenience."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
      "WhyChoosedescription": "Choose packages tailored to your schedule and travel preferences."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront pricing inclusive of fuel, tolls, and driver allowances for worry-free travel."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Hassle-Free Bookings",
      "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with your booking needs."
    },
    {
      "WhyChooseheading": "Ideal for Family and Group Pilgrimages",
      "WhyChoosedescription": "Our cabs cater to families and groups seeking a comfortable spiritual trip."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Needs",
      "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, and tempo travellers based on your group size and luggage."
    }
  ]




































    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services from Pune to Trimbakeshwar?',
        answer: 'Yes, Platinum24 Cabs offers safe, reliable, and comfortable cab services for travel between Pune and Trimbakeshwar.',
    },
    {
        question: 'How can I book a Pune to Trimbakeshwar cab with Platinum24 Cabs?',
        answer: 'You can book your cab via our website, mobile app, or by contacting our customer support team directly.',
    },
    {
        question: 'What types of vehicles are available for the Pune to Trimbakeshwar trip?',
        answer: 'We offer a wide range of vehicles including sedans, SUVs, tempo travellers, and luxury cars depending on your group size and comfort needs.',
    },
    {
        question: 'Are the drivers experienced for the Pune to Trimbakeshwar route?',
        answer: 'Yes, our drivers are professional, experienced, and well-versed with the Pune to Trimbakeshwar route and temple timings.',
    },
    {
        question: 'Can I book a round trip cab from Pune to Trimbakeshwar?',
        answer: 'Absolutely! We offer both one-way and round-trip cab packages with flexible scheduling options.',
    },
    {
        question: 'What is included in the fare for Pune to Trimbakeshwar cab services?',
        answer: 'Our fares include vehicle charges, fuel, driver allowance, tolls, and taxes. Any extra waiting or detour may incur additional charges.',
    },
    {
        question: 'Can I customize the pickup and drop-off locations for the Trimbakeshwar trip?',
        answer: 'Yes, you can choose your preferred pickup and drop-off locations within Pune and along the route to Trimbakeshwar.',
    },
    {
        question: 'Are hygiene and safety measures ensured for Trimbakeshwar trips?',
        answer: 'Yes, all our cabs are sanitized regularly, and our drivers follow strict hygiene and safety protocols to ensure your well-being.',
    },
    {
        question: 'Do you provide multi-day cab packages for pilgrimage tours including Trimbakeshwar?',
        answer: 'Yes, we offer customized multi-day travel packages that can include Trimbakeshwar along with other Jyotirling or temple destinations.',
    },
    {
        question: 'Does Platinum24 Cabs offer corporate or group travel services to Trimbakeshwar?',
        answer: 'Yes, we provide tailored services for corporate and group bookings with flexible billing and dedicated support.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Mahesh Sawant',
        feedback: 'Our trip from Pune to Trimbakeshwar with Platinum24 Cabs was smooth and spiritual. The cab was clean and the driver very polite.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Vaishnavi Kulkarni',
        feedback: 'Highly satisfied with the cab service to Trimbakeshwar. On-time pickup, knowledgeable driver, and overall great experience.',
        rating: 5,
    },
];














































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const puneToTrimbakeshwarSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Trimbakeshwar Cab",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-trimbakeshwar-cab.jpg",
  "description": "Book reliable Pune to Trimbakeshwar taxi services with Platinum24 Cabs. Comfortable and affordable cabs for your Trimbakeshwar pilgrimage tour with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-trimbakeshwar-cab"
  }
};





    return (
        <div>
<Helmet>
  <title>Pune to Trimbakeshwar Cabs | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Trimbakeshwar taxi service with Platinum24 Cabs. Affordable and comfortable cabs for pilgrimage tours with experienced drivers and easy booking."
  />
  <meta
    name="keywords"
    content="Pune to Trimbakeshwar Taxi Service, Trimbakeshwar Cab from Pune, Pune Trimbakeshwar Taxi Booking, Taxi for Trimbakeshwar Pilgrimage Pune, Pune to Trimbakeshwar Car Rental, Trimbakeshwar Taxi Packages Pune, Affordable Cab Pune to Trimbakeshwar, Pune Trimbakeshwar Private Taxi, Pune to Trimbakeshwar Taxi Fare, Trimbakeshwar Cab Charges Pune, Pune to Trimbakeshwar Taxi Hire, Trimbakeshwar Temple Taxi Service Pune, Pune to Trimbakeshwar One Way Cab, Pune Trimbakeshwar Taxi with Driver, Taxi Service Pune to Trimbakeshwar"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToTrimbakeshwarSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/41.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetotrimbkeshwarcabs;